import language from "./languageSelect";

const host = window.location.host;
const getHostTail = () => host.replace("cart.", "").replace("https://", "");

function getEditorUrl() {
  let editorUrl = "../editor";

  if (
    window.location.host.includes("localhost") &&
    !window.location.pathname.includes("cart")
  ) {
    editorUrl = "http://" + window.location.host.split(":")[0] + ":8080";
  }

  if (window.location.host.includes("cart.")) {
    const hostTail = getHostTail();

    editorUrl = "https://editor." + hostTail;
  }
  return editorUrl;
}

// the backend to be used is now configured in vue.config.js as a proxy :)
function getAPIEndpoint() {
  return "/backend"; 
}

function getRootDomain() {
  // getting the root domain
  const temp = location.host.split(".").reverse();
  let root_domain = temp[0];
  if (temp.length > 1) {
    // Root Domain ex (.nachthimmel.de)
    root_domain = "." + temp[1] + "." + root_domain;
  } else {
    // LocalHost Domain
    root_domain = root_domain.split(":")[0];
  }
  return root_domain;
}
const backendUrl = getAPIEndpoint();
const editorUrl = getEditorUrl();
const rootDomain = getRootDomain();

export { editorUrl, language, backendUrl, rootDomain };
